import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const googleAdsService = {
  getAuthorizationUrl: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.GOOGLE_ADS.AUTHORIZE);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          authorizationUrl: response.data.authorizationUrl,
          state: response.data.state
        };
      }

      return {
        success: false,
        error: response?.responseMessage || 'Failed to get authorization URL'
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to get authorization URL'
      };
    }
  },

  getIntegrationStatus: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.GOOGLE_ADS.STATUS);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          ...response.data
        };
      }

      return {
        success: false,
        error: response?.responseMessage || 'Failed to get integration status'
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to get integration status'
      };
    }
  },

  disconnect: async () => {
    try {
      const response = await post(API_ENDPOINTS.CRM.GOOGLE_ADS.DISCONNECT);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          message: response.responseMessage || 'Google Ads disconnected successfully'
        };
      }

      return {
        success: false,
        error: response?.responseMessage || 'Failed to disconnect Google Ads'
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to disconnect Google Ads'
      };
    }
  }
  ,

  syncLeads: async () => {
    try {
      const response = await post(API_ENDPOINTS.CRM.GOOGLE_ADS.SYNC);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          ...response.data
        };
      }

      return {
        success: false,
        error: response?.responseMessage || 'Failed to sync Google Ads leads'
      };
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to sync Google Ads leads'
      };
    }
  }
};

export default googleAdsService;

